var ContentLayoutComponent = /** @class */ (function () {
    function ContentLayoutComponent() {
    }
    return ContentLayoutComponent;
}());
export { ContentLayoutComponent };
